module.exports = __webpack_public_path__ + "fonts/source-sans-pro-v21-latin-300.d639dc8a.eot";